import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Layout from '~/src/layout/_layout';
import Equip from '~/src/layout/equipment';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getShopItems, EShopCategory, EExpandShopItems } from '~/src/api/content/shop/getShopItems.ts';
import { selectDomain } from '~/src/store/selectors/domain';
import { getQuizData } from '~/src/store/actions/quiz';
import { getBanners } from '~/src/api/banners';
import { sortFunction } from '~/src/helpers/functions';


const aliasForQuiz = 'routers';

class EquipmentPage extends Component {
    static propTypes = {
        city: PropTypes.object,
        hostname: PropTypes.string,
    };

    static async getInitialProps(options) {
        const { store } = options;
        const { hostname } = await initialProps(options);

        const state = store.getState();
        const billingDomain = selectDomain(state);
        const { city: { currentCity: city }, auth: { accessToken } } = state;

        // TODO getQuizData - скорее всего не используется, так как тарифы не запрашиваются и не устанавливаются в state.quiz
        const [shopItemsResp, bannerResp] = await Promise.all([
            getShopItems(
                billingDomain,
                accessToken,
                EShopCategory.Routers,
                [EExpandShopItems.Category, EExpandShopItems.Labels, EExpandShopItems.Props],
            ),
            getBanners(city.domain, false, 'equipmentwifi'),
            store.dispatch(getQuizData(billingDomain, aliasForQuiz)),
        ]);

        const productList = shopItemsResp
            .sort(sortFunction)
            .map(item => ({ ...item, alias: item.alias?.replace(new RegExp('\-im$'), '') }));

        const banner = bannerResp?.data?.items[0]?.bannerInfo;

        return { city, hostname, productList, banner };
    }

    render() {
        const { city, hostname, productList, banner } = this.props;

        return (
            <Layout
                title={`Купить Wi-Fi роутер от Дом.ру в ${city.cityIn}, цены на оборудование для подключения домашнего интернета`}
                description={`Официальный сайт Дом.ру в ${city.cityIn}| Оформите заявку на получение Wi-Fi роутера в рассрочку. Модели и цены на сайте. Оформить заказ: ${city.callCenter}`}
                hostname={hostname}
                withMenu={true}
                withChat={true}
                withFooter={true}
                relCanonical={`https://${hostname}/internet/equipment`}
            >
                <Equip city={city} productList={productList} banner={banner} />
            </Layout>
        );
    }
}

export default EquipmentPage;
